export default function products(jQuery) {

    jQuery(window).on('popstate', function() {
        if(document.location.search.length === 0) {
            document.location = document.location;
        }
    });
}
